module.exports = __webpack_public_path__ + "img/show-content.bf9e73da.png";